import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Home, FileText, ShieldCheck, User, Plus } from 'lucide-react';

const TABS = [
  { to: '/', label: 'Home', icon: Home, end: true },
  { to: '/documenti', label: 'Documenti', icon: FileText, end: false },
  { to: '/garanzie', label: 'Garanzie', icon: ShieldCheck, end: false },
  { to: '/profilo', label: 'Profilo', icon: User, end: false },
] as const;

export function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isActive = (to: string, end: boolean) => (end ? pathname === to : pathname.startsWith(to));

  // FAB centrale: voci [Home, Documenti] · [+] · [Garanzie, Profilo].
  const left = TABS.slice(0, 2);
  const right = TABS.slice(2);

  return (
    <nav className="bottomnav" aria-label="Navigazione principale">
      {left.map((t) => (
        <NavItem key={t.to} {...t} active={isActive(t.to, t.end)} onClick={() => navigate(t.to)} />
      ))}
      <button type="button" className="bottomnav__fab" aria-label="Aggiungi" onClick={() => navigate('/nuovo')}>
        <Plus size={24} />
      </button>
      {right.map((t) => (
        <NavItem key={t.to} {...t} active={isActive(t.to, t.end)} onClick={() => navigate(t.to)} />
      ))}
    </nav>
  );
}

function NavItem({
  label,
  icon: Icon,
  active,
  onClick,
}: {
  label: string;
  icon: typeof Home;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button type="button" className={`bottomnav__item${active ? ' is-active' : ''}`} onClick={onClick}>
      <Icon size={22} strokeWidth={2} />
      <span>{label}</span>
    </button>
  );
}

export function Sidebar() {
  const navigate = useNavigate();
  return (
    <aside className="sidebar">
      <div className="sidebar__logo">
        <span className="iconchip iconchip--sm iconchip--solid">
          <FileText size={18} />
        </span>
        Archivio
      </div>
      <nav className="sidebar__nav" aria-label="Navigazione principale">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) => `sidebar__link${isActive ? ' is-active' : ''}`}
          >
            <t.icon size={19} />
            {t.label}
          </NavLink>
        ))}
      </nav>
      <button type="button" className="btn btn--accent btn--block sidebar__cta" onClick={() => navigate('/nuovo')}>
        <Plus size={18} /> Nuovo documento
      </button>
    </aside>
  );
}
